import RequiredPermission from '@/assets/data/RequiredPermission'
import BodyCard from '@/Components/BodyCard'
import Datatable from '@/Components/Common/Datatable'
import HeaderCard from '@/Components/HeaderCard'
import { Button } from '@/Components/ui/button'
import { useAuth } from '@/Context/AuthContext'
import { checkPermission } from '@/utils/helper'
import { SquarePlus } from 'lucide-react'
import React, { useEffect, useReducer } from 'react'
import { Link, useLoaderData, useLocation, useNavigate } from 'react-router-dom'
import BulkUplaodColumn from './BulkUploadColumn'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import BulkUploadService from '@/Service/BulkUploadService'
import { Input } from '@/Components/ui/input'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'

const BulkUpload = () => {
    const { userInfo } = useAuth()
    const { bulkUpload } = useLoaderData()
    const navigate = useNavigate()
    const location = useLocation()

    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            bulkUploads: [],
            totalBulkUpload: 0,
            searchBulkUpladId: '',
            allCheck: false,
            deleteId: [],
            isDataFetching: false,
            queryParam: {
                page: 1,
                id: '',
            },
        }
    )

    const [searchBulkUploadId] = useDebounce(event.searchBulkUpladId, Constant.DEBOUNCE_DELAY)
    
    const getBulkUpload = async () => {
        updateEvent({ isDataFetching: true, bulkUploads: [] })
        try {
            const bulkUpload = await BulkUploadService.getBulkUploadRecords(event.queryParam)
            if (bulkUpload.data.success) {
                updateEvent({ bulkUploads: bulkUpload.data.data })
            }
        } catch {}
        updateEvent({ isDataFetching: false })
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getBulkUpload()
    }, [event.queryParam.page, event.queryParam.id])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                id: searchBulkUploadId,
            },
        })
    }, [searchBulkUploadId])

    useEffect(() => {
        updateEvent({ bulkUploads: bulkUpload })
    }, [bulkUpload])

    return (
        <>
            <HeaderCard>
                {checkPermission(RequiredPermission.PROCESS.CREATE, userInfo.roles) && (
                    <Button className="bg-primary-btn hover:bg-primary-purpal" onClick={() => navigate('/bulk-upload/new')}>
                        <SquarePlus />
                        Create Upload
                    </Button>
                )}
            </HeaderCard>
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.queryParam.id}
                        onChange={(e) =>
                            updateEvent({
                                queryParam: {
                                    ...event.queryParam,
                                    id: e.target.value,
                                },
                            })
                        }
                        placeholder="ID"
                    />
                </div>
                <Datatable
                    columns={BulkUplaodColumn()}
                    data={event.bulkUploads}
                    totalDataCount={event.totalBulkUpload}
                    allcheck={event.allCheck}
                    deleteId={event.deleteId}
                    updateEvent={updateEvent}
                    loading={event.isDataFetching}
                    type={DataTableEnumType.BULK_UPLOAD}
                />
            </BodyCard>
        </>
    )
}

export default BulkUpload
